var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Aide")]),_c('h4',[_vm._v("Débug : Données utilisateur")]),_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.userProfile, undefined, 4))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }